var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("Webheader.annuaire_file"),
        "show-filter": true,
        "show-refresh": true,
        "filter-expanded": _vm.displayFilter,
        "refresh-disabled": _vm.activateSpinner,
      },
      on: { "toggle-filter": _vm.toggleFilter, refresh: _vm.refreshAnnuaire },
      scopedSlots: _vm._u([
        {
          key: "primaryActions",
          fn: function () {
            return [
              _vm.canAddAnnuaireFile() && !_vm.activateSpinner
                ? _c("app-button", {
                    attrs: {
                      text: _vm.$t("annuaire.add_annuaire_file"),
                      icon: "fa-light fa-plus",
                      variant: "primary",
                    },
                    on: { click: _vm.addAnnuaireFile },
                  })
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("template", { slot: "navigationTabs" }, [
        _c("div", { staticClass: "d-block d-lg-none" }, [
          _c(
            "div",
            { staticClass: "d-flex flex-column" },
            _vm._l(_vm.tabs, function (tab, index) {
              return _c("app-button", {
                key: index,
                attrs: {
                  text: _vm.$t(tab.translationKey),
                  variant: _vm.tabName === tab.value ? "primary" : "light",
                  size: "md",
                  block: true,
                  "custom-class": "mb-2",
                },
                on: {
                  click: function ($event) {
                    return _vm.changeTabName(tab.value)
                  },
                },
              })
            }),
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-none d-lg-block" },
          [
            _c(
              "b-nav",
              { staticClass: "border-0", attrs: { tabs: "", fill: "" } },
              _vm._l(_vm.tabs, function (tab, index) {
                return _c(
                  "b-nav-item",
                  {
                    key: index,
                    class: {
                      "bg-primary text-white": _vm.tabName === tab.value,
                    },
                    attrs: { active: _vm.tabName === tab.value },
                    on: {
                      click: function ($event) {
                        return _vm.changeTabName(tab.value)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        class: {
                          "font-weight-bold": _vm.tabName === tab.value,
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t(tab.translationKey)) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "filterContent" },
        [
          _c("app-panel", {
            attrs: {
              filters: _vm.filterConfig,
              searchAriaLabel:
                _vm.$t("common.srch") + " " + _vm.$t("Webheader.annuaire_file"),
            },
            on: {
              "filter-changed": _vm.onFilterChanged,
              "clear-filters": _vm.clearFilterFields,
              "apply-filters": _vm.applyFilter,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c("b-container", { attrs: { fluid: "" } }, [
            _c("div", { staticClass: "requestsList" }, [
              _c(
                "div",
                { staticClass: "mt-0" },
                [
                  _vm.tabName === 1
                    ? _c("AnnuaireLineList", {
                        attrs: {
                          type: _vm.TrackType,
                          id: _vm.id,
                          showFilters: false,
                          filters: _vm.filterValues,
                        },
                        on: { refresh: _vm.refreshInbox },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tabName === 2
                    ? _c("AnnuaireFilePage", {
                        attrs: {
                          showFilters: false,
                          filters: _vm.filterValues,
                        },
                        on: { refresh: _vm.refreshInbox },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }